manifestAction = function (url, op) {
    event.preventDefault();
    if (confirm("Deseja executar esta operação?")) {
        let form = $('<form action="' + url + '" method="post"></form>');
        let formToken = $('meta[name="csrf-token"]').attr('content');
        let input1 = $('<input type="hidden" name="_token">').val(formToken);
        if (op == 1) {
            $('#manifest-justify').modal().find('.modal-footer button').on('click', function () {
                let $btn = $(this);
                let justify = $btn.closest('.modal-content').find('textarea').val();
                if (justify.length == 0 || justify.length > 255) {
                    alert("Jutificativa muito grande ou vazia");
                    return;
                }
                let input2 = $('<input type="hidden" name="justify">').val(justify);
                let input3 = $('<input type="hidden" name="op">').val(op);
                form.append(input1, input2, input3);
            });
        } else {
            let cks = $('[type="checkbox"].note:checked');
            if (cks.length == 0) {
                alert("Selecione um registro para continuar.");
                return;
            }
            cks.each(function (indx, element) {
                form.append($('<input type="hidden" name="ids[]">').val($(element).val()));
            });
            let input2 = $('<input type="hidden" name="op">').val(2);
            form.append(input1, input2);
        }
        form.hide().appendTo('body').submit();
    }
};

$('button#confirm').on('click', function () {
    let btn = $(this);
    let url = btn.data('url');
    manifestAction(url, 2); // "Confirmação da Operação",
});

$('button#ok').on('click', function () {
    let btn = $(this);
    let url = btn.data('url');
    manifestAction(url, 3); // "Ciência da Operação",
});

$('button#unknown').on('click', function () {
    let btn = $(this);
    let url = btn.data('url');
    manifestAction(url, 4); // Desconhecimento da Operação",
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/scripts/script-manifest-action.js